import React from 'react'
import { useAuth } from '@/modules/auth/context/AuthContext'
import { getTrialDaysLeft } from '../services/trialService'
import { getCurrentPlanForUser } from '../services/memberPlanService'

export type TrialStatus = {
  loading: boolean
  error: string | null
  daysLeft: number
  inTrial: boolean
  postTrialOnTrialPlan: boolean
  currentPlanId: string | null
  subscriptionIsTrial: boolean
  trialEndsAt: string | null
}

export function useTrialStatus(): TrialStatus {
  const { user } = useAuth()
  const [loading, setLoading] = React.useState(true)
  const [error, setError] = React.useState<string | null>(null)
  const [daysLeft, setDaysLeft] = React.useState(0)
  const [postTrialOnTrialPlan, setPostTrialOnTrialPlan] = React.useState(false)
   const [currentPlanId, setCurrentPlanId] = React.useState<string | null>(null)
  const [subscriptionIsTrial, setSubscriptionIsTrial] = React.useState(false)
  const [trialEndsAt, setTrialEndsAt] = React.useState<string | null>(null)

  const load = React.useCallback(async () => {
    if (!user?.id) {
      setDaysLeft(0)
      setPostTrialOnTrialPlan(false)
      setCurrentPlanId(null)
      setSubscriptionIsTrial(false)
      setTrialEndsAt(null)
      setLoading(false)
      return
    }
    setLoading(true)
    setError(null)
    try {
      const [n, cur] = await Promise.all([
        getTrialDaysLeft(),
        getCurrentPlanForUser(user.id),
      ])
      const planId = (cur.plan?.id as string | undefined) || (cur.subscription?.plan_id as string | undefined) || ''
      const inTrial = n > 0
      const onTrialPlan = planId === 'trial_7d'
      setDaysLeft(n)
      setPostTrialOnTrialPlan(!inTrial && onTrialPlan)
      setCurrentPlanId(planId || null)
      const sub: any = cur.subscription || null
      setSubscriptionIsTrial(!!sub?.is_trial)
      setTrialEndsAt((sub?.trial_ends_at as string | null) || null)
    } catch (e: any) {
      setError(e?.message || 'Falha ao carregar status do plano')
      setDaysLeft(0)
      setPostTrialOnTrialPlan(false)
      setCurrentPlanId(null)
      setSubscriptionIsTrial(false)
      setTrialEndsAt(null)
    } finally {
      setLoading(false)
    }
  }, [user?.id])

  React.useEffect(() => {
    load()
  }, [load])

  return {
    loading,
    error,
    daysLeft,
    inTrial: daysLeft > 0,
    postTrialOnTrialPlan,
    currentPlanId,
    subscriptionIsTrial,
    trialEndsAt,
  }
}
